import { range } from "@/ui/utils/ranges"
import { ThemeColor, classNames } from "@punks/ui-core"
import React, { useMemo } from "react"

export type SlideType = "bars" | "circles"

export interface SlidePositionProps {
  currentSlideNumber: number
  slidesCount: number
  className?: string
  type: SlideType
  color: ThemeColor
}

const SlidePosition = ({
  currentSlideNumber,
  slidesCount,
  className,
  type,
  color,
}: SlidePositionProps) => {
  const slides = useMemo(() => {
    return range(slidesCount)
  }, [slidesCount])
  if (type === "bars") {
    return (
      <div className={`flex gap-[10px] ${className ?? ""}`}>
        {slides.map((x) => {
          return (
            <div
              key={x}
              className={classNames("h-[5px] rounded-[5px]", {
                "w-[28px]": currentSlideNumber === x,
                "w-[9px]": currentSlideNumber !== x,
                "bg-primary": color === "primary",
                "bg-paper": color === "paper",
              })}
            />
          )
        })}
      </div>
    )
  }
  if (type === "circles") {
    return (
      <div
        style={{}}
        className="relative flex items-center justify-center w-full"
      >
        {slides.map((x) => {
          return (
            <div
              key={x}
              className={classNames(
                "flex max-w-[54px] items-center after:w-[10px] after:h-[10px] after:rounded-full after:block",
                currentSlideNumber >= x
                  ? "before:bg-red after:bg-primary"
                  : "before:bg-light after:bg-light",
                x > 0 &&
                  "flex-1 before:max-w-[44px] before:h-[1px] before:block before:flex-1"
              )}
            />
          )
        })}
      </div>
    )
  }
  return null
}

export default SlidePosition
